import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Template from 'components/content/Template'
import EstimatesPage from 'containers/EstimatesPage'
import EstimatesStartPage from 'containers/EstimatesStartPage'
import EstimateCreatePage from 'containers/EstimateCreatePage'
import EstimateCreatedPage from 'components/estimates/EstimateInfo'
import EstimateView from 'containers/EstimateView'
import EstimatesMyDetailPage from 'containers/EstimatesMyDetailPage'
import EstimateEditPage from 'containers/EstimateEditPage'
import CmsReportPage from 'containers/CmsReportPage'
import ProfilePage from 'containers/ProfilePage'
import { PrivateRoute } from 'routes'
import { routePath } from 'routes'
import AuthRoutes from './AuthRoutes'
import PatientsListPage from '../containers/PatientsListPage'
import PatientDetailPage from '../containers/PatientDetailPage'
import CPT4ListPage from '../containers/CPT4ListPage'
import MostActiveCPT4Page from '../containers/MostActiveCPT4Page'
// import PatientDetailPage from '../containers/PatientDetailPage'
import EstimateCreationByEmail from '../containers/EstimateCreationByEmail/EstimateCreationByEmail'

const Routes = () => (
  <Template>
    <Switch>
      <PrivateRoute path={routePath.PROFILE} component={ProfilePage} />
      <PrivateRoute
        path={routePath.ESTIMATE_MY_DETAIL}
        component={EstimatesMyDetailPage}
      />
      <PrivateRoute
        path={routePath.ESTIMATE_EDIT}
        component={EstimateEditPage}
      />
      <Route
        path={routePath.ESTIMATE_CREATE}
        component={EstimateCreatePage}
      />
      <Route
        path={routePath.ESTIMATE_CREATED}
        component={EstimateCreatedPage}
      />
      <Route
        path={routePath.ESTIMATE_CREATION_BY_EMAIL}
        component={EstimateCreationByEmail}
      />
      <Route
        path={routePath.ESTIMATE_VIEW}
        component={EstimateView}
      />
      <Route
        path={routePath.ESTIMATES_START_PAGE}
        component={EstimatesStartPage}
      />
      <PrivateRoute path={routePath.ESTIMATES_PAGE} component={EstimatesPage} />
      <PrivateRoute
        path={routePath.PATIENTS_LIST}
        component={PatientsListPage}
      />
      <PrivateRoute
        path={routePath.PATIENT_DETAIL_PAGE}
        component={PatientDetailPage}
      />
      <PrivateRoute
        path={routePath.CPT4_LIST}
        component={CPT4ListPage}
      />
      <PrivateRoute
        path={routePath.MOST_ACTIVE_CPT4_LIST}
        component={MostActiveCPT4Page}
      />
      {/* <PrivateRoute
        path={routePath.PATIENT_DETAIL_PAGE}
        component={PatientDetailPage}
      /> */}
      <Route
        path={routePath.CMS_REPORT}
        component={CmsReportPage}
      />
      <Route path={routePath.AUTH} component={AuthRoutes} />
      <Redirect to={routePath.ESTIMATES_PAGE} />
    </Switch>
  </Template>
)

export default Routes
